/**
 * Consent Service - manages user privacy consent state
 * Used for GDPR/privacy compliance with Mixpanel tracking
 */

import localSave from '@utils/local-save'
import mixpanelService from './mixpanel-service'

const STORAGE_KEY = 'frisky_privacy_consent'

class ConsentService {
    constructor() {
        if (ConsentService.instance) {
            return ConsentService.instance
        }
        ConsentService.instance = this
    }

    /**
     * Check if user has given consent
     * @returns {boolean}
     */
    hasConsent() {
        const consent = this.getConsentData()
        return !!(consent && consent.agreed === true)
    }

    /**
     * Grant consent and enable tracking
     * @param {string} source - Where consent was granted ('banner' | 'signup')
     */
    grantConsent(source = 'banner') {
        const consentData = {
            agreed: true,
            timestamp: new Date().toISOString(),
            source
        }

        try {
            localSave.save(STORAGE_KEY, consentData)
            mixpanelService.optIn()
        } catch (error) {
            console.error('ConsentService: Failed to save consent', error)
        }
    }

    /**
     * Get the full consent data object
     * @returns {Object|null} Consent data or null if not set
     */
    getConsentData() {
        try {
            return localSave.get(STORAGE_KEY)
        } catch (error) {
            console.error('ConsentService: Failed to read consent', error)
            return null
        }
    }

    /**
     * Restore consent state on app initialization
     * Should be called after Mixpanel is initialized
     */
    restoreConsentState() {
        if (this.hasConsent()) {
            mixpanelService.optIn()
        }
    }
}

export default new ConsentService()
